import { Component } from '@angular/core';
import { BaseMortgageApplicationComponent } from '../../../pages/base-mortgage-application.component';
import { Address } from './../../../../../lib/models/api/address.model';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-your-property-contacts',
  templateUrl: './your-property-contacts.component.html',
  styleUrls: ['./your-property-contacts.component.scss']
})
export class YourPropertyContactsComponent extends BaseMortgageApplicationComponent {
  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }

  public initialize(): void {
    this.initializePropertySellingEstateAgentAddress();
  }

  initializePropertySellingEstateAgentAddress(): void {
    this.mortgageApplication.PropertySellingEstateAgentAddress.CountryTypeCode = this.referenceDataLabels.CountryUk;
    this.mortgageApplication.PropertySellingEstateAgentAddress.FromPaf = true;
  }

  setInitialContactAddressCountry(): void {
    this.mortgageApplication.PropertyAccessContactAddress.CountryTypeCode = this.mortgageApplication
      .PropertyAccessContactAddress
      ? this.referenceDataOptionLists.CountryTypeUk
      : '';
  }
}
